/** Produto do cadastro escolhido para um item avulso da compra. */
export class AssociarProdutoItemAvulsoRequest {
  idCompraItem: number;
  idProduto: number;
  codigoSku?: string | null;
  nome: string;
  marca?: string | null;
  unidade?: string | null;
}
